export default "__VITE_ASSET__69efbc42__"